import { socialMediaLinks } from "../../data/socialMediaLinks";

export function Footer() {
    return (
        <footer className="bg-primary text-white py-10 flex flex-col gap-5 items-center">
            <a
                href="mailto:gabaniparth04@gmail.com"
                className="hover:opacity-80"
            >
                gabaniparth04@gmail.com
            </a>
            <div className="text-3xl flex gap-10">
                {socialMediaLinks.map((socialMedia) => (
                    <a
                        href={socialMedia.url}
                        className="hover:opacity-80"
                        key={socialMedia.icons}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {socialMedia.iconURL ? (
                            <img
                                src={socialMedia.iconURL}
                                alt="social"
                                className="h-[30px]"
                            />
                        ) : (
                            <i className={`fab ${socialMedia.icons}`}></i>
                        )}
                    </a>
                ))}
            </div>
        </footer>
    );
}
